import { render } from "./SetupView.vue?vue&type=template&id=3498dc25&scoped=true&ts=true"
import script from "./SetupView.vue?vue&type=script&lang=ts"
export * from "./SetupView.vue?vue&type=script&lang=ts"

import "./SetupView.vue?vue&type=style&index=0&id=3498dc25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3498dc25"]])

export default __exports__